import { initPage } from '../api';
import { Message } from 'element-ui';
const mytask = {
  namespaced: true,
  state: {
    initPageObj: {},
  },
  mutations: {
    INIT_PAGE_DATA(state, resp) {
      state.initPageObj = resp.obj || {};
    }
  },
  actions: {
    async initPage({ commit }, obj) {
      let resp = await initPage(obj);
      commit('INIT_PAGE_DATA', resp);
    }
  }
}

export default mytask



// WEBPACK FOOTER //
// ./src/page/mytask/mytask/store/mytask.store.js